var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { debugFactory } from '@iva/debugger';
export var DEBUG_CONFIG = {
    name: 'component-spenttime',
    bColor: '#35b5a2',
    fColor: '#fff',
};
// states for the debugger
export var DEBUG_STATES = {
    START: 'start',
    DONE: 'done',
    ERROR: 'error',
};
// Use the parameter ?sznivadbg=1 or ?sznivadbg=component-spenttime for debugging
var debug = debugFactory(DEBUG_CONFIG);
export var debugObject = function (obj) {
    var str = JSON.stringify(obj);
    str.replace(/\}/g, '\n}\n');
    str.replace(/\{/g, '\n}\n');
    debug(str);
};
export var spenttimeDebug = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var dateOptions = {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    };
    var time = new Intl.DateTimeFormat('cz-CS', dateOptions).format(new Date()) + ' ';
    if (args.length === 1 && typeof args[0] === 'string') {
        debug(time + args[0]);
        return;
    }
    if (args.length === 1 && typeof args[0] === 'object') {
        var obj = args[0];
        var message = obj.message;
        debug(__assign(__assign({}, args[0]), { message: time + message }));
        return;
    }
    debug(args);
};
